import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { Blueprint } from './types/blueprint.type';

/**
 * Fetches a blueprint by its unique identifier.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param id - The unique identifier of the blueprint to retrieve.
 * @returns A promise that resolves to the requested {@link Blueprint}.
 * @throws Will throw an error if the request fails.
 */
export const getBlueprint = async (instance: KyInstance, id: number) => {
  try {
    return await instance
      .get<OperationResultWithData<Blueprint>>(formatString(Uri.blueprint.byId, id.toString()))
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
